import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getWhiteLabelOrganization(props: { axios: AxiosInstance }): Promise<any> {
  const { axios } = props;

  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/wap-users`);
  return data;
}

export default function useWhiteLabelOrganizationUsersQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getWhiteLabelOrganization({ axios }),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['Whitelabel Organization Users'] as const satisfies QueryKey;
}
useWhiteLabelOrganizationUsersQuery.getKey = getKey;
